import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import CustomLink from '../CustomLink';
import logoSrc from '../../assets/images/futureproof-logo.png';
import styles from './Logo.css';

const cx = classnames.bind(styles);

function Logo({ className, onClick, url }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <CustomLink
            to={url}
            className={classes}
            onClick={onClick}
        >
            <img src={`${logoSrc}?v=2`} alt='Futureproof' />
        </CustomLink>
    );
}

Logo.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    url: PropTypes.string
};

Logo.defaultProps = {
    onClick: null,
    className: '',
    url: '/'
};

export {
    Logo
};
